export const appsAppGroup = "/apps/app_group";
